import { isSafari, isIE, isEdge } from 'react-device-detect';

const isTIFFImageSupported = () => isSafari || isIE || isEdge;

export default {
  isTIFFImageSupported,
};
